module.exports = __webpack_public_path__ + "img/sLightnWmn_193x205.1924b62d.png";